import axios from '@/axios/axios'
import * as validationUtil from '@/utils/validationUtil'

const createSurvey = function(){
  return {
    idx: 0,
    target: '',
    title: '',
    introduction: '',
    regDate: '',
    startDate: '',
    endDate: '',
    useYn: 'Y',
    surveyUserCount: 0,
    items: []
  }
}

const createItem = function(){
  return{
    idx: 0,
    surveyIdx: 0,
    type: '', 
    order: 0, 
    question: '', 
    essential: 'N', 
    options:[],
    answer: {}
  }
}

const createOption = function(){
  return {
    idx: 0,
    surveyItemIdx: 0,
    order: 0,
    data: ''
  }
}

const createAnswer = function(){
  return{
    idx: 0,
    surveyIdx: 0,
    surveyItemIdx: 0,
    userIdx: 0,
    data:'',
    regDate: ''
  }
}

export default {
    namespaced: true,
    state:{
      survey: createSurvey()
    },
    mutations:{
      setSurvey: (state,{
        idx,
        target,
        title,
        introduction,
        regDate,
        startDate,
        endDate,
        useYn,
        surveyUserCount,
        items
      }) => {
        state.survey.idx = idx,
        state.survey.target = target,
        state.survey.title = title,
        state.survey.introduction = introduction,
        state.survey.regDate = regDate,
        state.survey.startDate = startDate,
        state.survey.endDate = endDate,
        state.survey.useYn = useYn,
        state.survey.surveyUserCount = surveyUserCount,
        state.survey.items = items == null ? [] : items
      },
      resetSurvey:(state) => {
        state.survey.items = []
        state.survey = createSurvey()
      },
      addItem: (state, {
        idx,
        surveyIdx,
        type,
        order,
        question,
        essential,
        options,
        answer,
      }) => {
        var item = createItem()
        if(!validationUtil.isEmpty(idx)) item.idx = idx
        if(!validationUtil.isEmpty(surveyIdx)) item.surveyIdx = surveyIdx
        if(!validationUtil.isEmpty(type)) item.type = type
        if(!validationUtil.isEmpty(order)) item.order = order
        if(!validationUtil.isEmpty(question)) item.question = question
        if(!validationUtil.isEmpty(essential)) item.essential = essential
        item.options = options == null ? [] : options
        item.answer = answer == null ? {} : answer
        
        state.survey.items.push(item)
      },
      deleteItem: (state, index) => {
        var old = state.survey.items
        old.splice(index, 1)
        for(var i = 0; i < old.length; i++){
          old[i].order = i + 1
        }
  
        state.survey.items = []
        state.survey.items = old
      },
      setOptions(state, {item, list}){
        item.options = []
        for(var i = 0; i < list.length; i++){
          var option = createOption()
          option.data = list[i]
          option.order = i

          if(item.type === 'LINEAR' && list[i] === 'BLANK'){
            continue
          }

          item.options.push(option)
        }
      }
    },
    getters:{
      getSurvey: state => state.survey
    },
    actions:{
      saveAnswer(context, payload){
        return axios
        .post('/api/survey/saveAnswer', {
          surveyIdx: payload.surveyIdx,
          userIdx: payload.userIdx,
          answerJsonString: payload.answerJsonString,
          isFinal: payload.isFinal
        })
        .then(response => {
          return Promise.resolve(response)
        })
        .catch(error => {
          console.log(error)
          return Promise.reject(error)
        })
      },
      saveSurvey(context, payload){
        return axios
        .post('/api/survey/saveSurvey', {
          jsonString: payload.jsonString,
          isStart: payload.isStart
        })
        .then(response => {
          return Promise.resolve(response)
        })
        .catch(error => {
          console.log(error)
          return Promise.reject(error)
        })
      },
      deleteSurvey(context, surveyIdxList){
        return axios
        .post('/api/survey/deleteSurvey', surveyIdxList)
        .then(response => {
          return Promise.resolve(response)
        })
        .catch(error => {
          console.log(error)
          return Promise.reject(error)
        })
      },
      requestList(context, payload){
        return axios
        .post('/api/survey/requestList', {
          currentPage: payload.currentPage,
          perPage: payload.perPage,
          sortBy: payload.sortBy,
          sortDesc: payload.sortDesc,
          searchText : payload.searchText
        })
        .then(response => {
          return Promise.resolve(response)
        })
        .catch(error => {
          console.log(error)
          return Promise.reject(error)
        })
      },
      requestListForCustomer(context, payload){
        return axios
        .post('/api/survey/requestListForCustomer', null,  {params: {
          currentPage: payload.currentPage,
          perPage: payload.perPage,
          sortBy: payload.sortBy,
          sortDesc: payload.sortDesc,
          searchText : payload.searchText,
          period: payload.period,
          target: payload.target,
          userIdx: payload.userIdx
        }})
        .then(response => {
          return Promise.resolve(response)
        })
        .catch(error => {
          console.log(error)
          return Promise.reject(error)
        })
      },
      requestDetail({commit}, payload){
        return axios
        .post('/api/survey/requestDetail', null, {params: {
          surveyIdx: payload.surveyIdx,
          userIdx: payload.userIdx
        }})
        .then(response => {
          const data = response.data
          if(data == null){
            return Promise.reject("Not found data.")
          }

          if(data.RESULT == false){
            return Promise.reject("Failed to request survey detail.")
          }

          const survey = data.DATA.survey
          const items = survey.items

          commit("setSurvey", {
            idx: survey.IDX,
            target: survey.TARGET,
            title: survey.TITLE,
            introduction: survey.INTRODUCTION,
            regDate: survey.REGDATE,
            startDate: survey.START_DATE,
            endDate: survey.END_DATE,
            useYn: survey.USE_YN
          })

          for(var i = 0; i < items.length; i++){
            const item = items[i]
            
            var answer = {}
            if(item.answer != null && typeof item.answer != 'undefined'){
              answer = createAnswer()
              answer.idx = item.answer.IDX
              answer.surveyIdx = item.answer.SURVEY_IDX
              answer.surveyItemIdx = item.answer.SURVEY_ITEM_IDX
              answer.userIdx = item.answer.USER_IDX
              answer.surveyOptionIdx = item.answer.SURVEY_OPTION_IDX
              answer.data = item.answer.DATA
              answer.regDate = item.answer.REGDATE
            }

            var options = []
            if(item.options != null && typeof item.options != 'undefined'){
              for(var j = 0; j < item.options.length; j++){
                var option = createOption()
                option.idx = item.options[j].IDX
                option.surveyItemIdx = item.options[j].SURVEY_ITEM_IDX
                option.order = item.options[j].ORDER
                option.data = item.options[j].DATA

                options.push(option)
              }
            }

            commit("addItem", {
              idx: items[i].IDX,
              surveyIdx: items[i].SURVEY_IDX,
              type: items[i].TYPE,
              order: items[i].ORDER,
              question: items[i].QUESTION,
              essential: items[i].ESSENTIAL,
              options: options,
              answer: answer
            })
          }
          return Promise.resolve(response)
        })
        .catch((error) => {
          console.log(error)
          return Promise.reject(error)
        })
      },
      updateDateSurvey(context, payload){
        return axios
        .post('/api/survey/updateDateSurvey', {
          jsonString: payload.jsonString,
          isStart: payload.isStart
        })
        .then(response => {
          return Promise.resolve(response)
        })
        .catch(error => {
          console.log(error)
          return Promise.reject(error)
        })
      },
      requestSurveyStatics({commit}, payload){
        return axios
        .post('/api/survey/requestSurveyStatics', null, {params: {
          surveyIdx: payload.surveyIdx
        }})
        .then(response => {
          const data = response.data
          if(data == null){
            return Promise.reject("Not found data.")
          }

          if(data.RESULT == false){
            return Promise.reject("Failed to request survey detail.")
          }

          const survey = data.DATA.survey
          const items = survey.items

          commit("setSurvey", {
            idx: survey.IDX,
            target: survey.TARGET,
            title: survey.TITLE,
            introduction: survey.INTRODUCTION,
            regDate: survey.REGDATE,
            startDate: survey.START_DATE,
            endDate: survey.END_DATE,
            useYn: survey.USE_YN,
            surveyUserCount: survey.SURVEY_USER_COUNT
          })

          for(var i = 0; i < items.length; i++){
            const item = items[i]
            
            var options = []
            if(item.options != null && typeof item.options != 'undefined'){
              for(var j = 0; j < item.options.length; j++){
                var option = createOption()
                option.idx = item.options[j].IDX
                option.surveyItemIdx = item.options[j].SURVEY_ITEM_IDX
                option.order = item.options[j].ORDER
                option.data = item.options[j].DATA
                option.percent = item.options[j].PERCENT
                
                options.push(option)
              }
            }

            commit("addItem", {
              idx: items[i].IDX,
              surveyIdx: items[i].SURVEY_IDX,
              type: items[i].TYPE,
              order: items[i].ORDER,
              question: items[i].QUESTION,
              essential: items[i].ESSENTIAL,
              options: options,
              answer: null
            })
          }
          return Promise.resolve(response)
        })
        .catch((error) => {
          console.log(error)
          return Promise.reject(error)
        })
      },
    }
}